const subscribeEvents = {
    IN_APP_MESSAGE: 'inAppMessage',
    CONTENT_CARDS: 'contentCards',
};
const publishEvents = {
    SET_CUSTOM_USER_ATTRIBUTE: 'setCustomUserAttribute',
    IN_APP_MESSAGE_SHOWN: 'inAppMessage.shown',
    IN_APP_MESSAGE_CLICKED: 'inAppMessage.clicked',
    IN_APP_MESSAGE_BUTTON_CLICKED: 'inAppMessageButton.clicked',
    IN_APP_MESSAGE_HTML_CLICKED: 'inAppMessageHTML.clicked',
    CONTENT_CARD_SHOWN: 'contentCard.shown',
    CONTENT_CARD_CLICKED: 'contentCard.clicked',
};
export { subscribeEvents, publishEvents };
//# sourceMappingURL=Events.js.map